module.exports = "/_next/static/resources/array-9e797f3a8456ed865e30533e61644662.jpg";